<template>
  <confirmation-dialog ref="dialog" close-on-action>
    <template v-slot:body>
        <div>
          <label class="a-label a-width-100-percent">Укажите номер лота, из которого нужно скопировать документ:</label>
          <dropdown-new :options="options"
                        v-model="value">
          </dropdown-new>
        </div>
    </template>
  </confirmation-dialog>
</template>

<script>
  import ConfirmationDialog from "./ConfirmationDialog";

  export default {
    data: () => ({
      value: undefined,
      options: []
    }),

    components: {
      ConfirmationDialog
    },

    methods: {
      open({options, onConfirm}) {
        this.options = options || [];

        this.$refs.dialog.open({
          title: 'Копирование документа',
          onConfirm: () => {
            onConfirm(this.value);
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
